import { NbcId } from '@app/app.constants';

export interface JsonTvBatchUpdateFileType {
  id: number;
  name: string;
}

export interface JsonTvBatchCreationFileType {
  id: number;
  name: string;
}

export class TvBatchUpdateFileType {
  id: number;
  name: string;
  constructor(jsonTvBatchUpdateFileType: JsonTvBatchUpdateFileType = null) {
    this.id = Number(jsonTvBatchUpdateFileType.id);
    this.name = jsonTvBatchUpdateFileType.name;
  }
}

export class TvBatchCreationFileType {
  id: number;
  name: string;
  constructor(jsonTvBatchCreationFileType: JsonTvBatchCreationFileType = null) {
    this.id = jsonTvBatchCreationFileType.id;
    this.name = jsonTvBatchCreationFileType.name;
  }
}

export interface JsonTvChannelGroup {
  id: number;
  channelGroup: string;
  isNat: boolean;
  name: string;
}

export class TvChannelGroup {
  id: number;
  channelGroup: string;
  isNat: boolean;
  name: string;

  constructor(jsonTvChannelGroup: JsonTvChannelGroup = null) {
    this.id = jsonTvChannelGroup.id;
    this.channelGroup = jsonTvChannelGroup.channelGroup;
    this.isNat = !!jsonTvChannelGroup.isNat;
    this.name = jsonTvChannelGroup.name;
  }
}

export interface JsonTvChannel {
  id: number;
  name: string;
  channelCode: string;
  regionCode: string;
  isRegion: boolean;
  logo: string;
  _embedded: {
    channelGroup: {
      numRegie: string;
      nomRegie: string;
    };
    editor: {
      editorId: string;
      editorName: string;
    };
    priceListType: {
      id: string;
      priceListTypeLabel: string;
    };
    tvBatchUpdateFileTypes: JsonTvBatchUpdateFileType[];
    tvBatchCreationFileTypes: JsonTvBatchCreationFileType[];
  };
  digitalId?: string;
}

export class TvChannel {
  id: number;
  name: string;
  channelCode: string;
  regionCode: string;
  isRegion: boolean;
  logo: string;
  isFavorite = false;
  nomRegie: string = 'Pas de regie';
  editorName: string;
  isNbc: boolean = false;
  priceListCreationTypeId: number | null;
  batchUpdateFileTypes: TvBatchUpdateFileType[] = [];
  batchCreationFileTypes: TvBatchCreationFileType[] = [];
  digitalId?: string = '';

  constructor(jsonTvChannel: JsonTvChannel = null, isFavorite?) {
    this.id = jsonTvChannel.id;
    this.name = jsonTvChannel.name;
    this.channelCode = jsonTvChannel.channelCode;
    this.regionCode = jsonTvChannel.regionCode;
    this.isRegion = jsonTvChannel.isRegion;
    this.logo = jsonTvChannel.logo;
    this.isFavorite = !!isFavorite;
    this.nomRegie = jsonTvChannel?._embedded?.channelGroup?.nomRegie;
    this.priceListCreationTypeId =
      jsonTvChannel?._embedded?.priceListType?.id != null ? Number(jsonTvChannel._embedded.priceListType.id) : null;
    this.isNbc = jsonTvChannel._embedded?.editor?.editorId == NbcId;
    if (
      jsonTvChannel &&
      jsonTvChannel._embedded &&
      jsonTvChannel._embedded.tvBatchUpdateFileTypes &&
      jsonTvChannel._embedded.tvBatchUpdateFileTypes
    ) {
      this.batchUpdateFileTypes = jsonTvChannel._embedded.tvBatchUpdateFileTypes.map((fileTypeJson: JsonTvBatchUpdateFileType) => {
        return new TvBatchUpdateFileType(fileTypeJson);
      });
    }
    if (
      jsonTvChannel &&
      jsonTvChannel._embedded &&
      jsonTvChannel._embedded.tvBatchCreationFileTypes &&
      jsonTvChannel._embedded.tvBatchCreationFileTypes
    ) {
      this.batchCreationFileTypes = jsonTvChannel._embedded.tvBatchCreationFileTypes.map((fileTypeJson: JsonTvBatchCreationFileType) => {
        return new TvBatchCreationFileType(fileTypeJson);
      });
    }
    this.digitalId = jsonTvChannel.digitalId ?? '';
  }
}
